/** @jsx jsx */

import React, { Fragment as _, memo, useMemo, createContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import getTempTextImageData from 'services/getTempTextImageContinueBtnData';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';

import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import HotSpot from './HotSpot';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import EditableBtn from 'components/lib/EditableBtn';
import IELayout from 'components/Layouts/IELayout';
import Modal from 'components/UI/Modal';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import DragNDrop from './HotSpot';
import shouldUpdate from 'services/shouldUpdate';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Image: ({ children, ...props }) => (
    <Image
      {...{
        ...props,
        usePlaceholderValue: true,
        maxHeight: 30,
      }}
    />
  ),
  // Image,
  Video,
  // SVG: ({ children, ...props }) => (
  //   <SVG {...{ ...props, editWrapperType: 1 }} />
  // ),
  SVG,
  Media,
  //({ children, ...props }) => <EditableBtn {...props} />,
  HotSpotElement: ({ children, ...props }) => children,
  HotSpotIsolated: HotSpot,
  Answer: () => null,
  Feedback: () => null,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Modal: () => null,
  ModalWithEditableBtn: () => null,
  ...IELayout(interactionContext),
};

const HotSpotDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate);

// const HotSpotDisplay = props => {
//   const interactionBlock = getBlockById(props.blockId);

//   const container = (
//     <Container
//       id={interactionBlock.id}
//       key={interactionBlock.id}
//       {...interactionBlock.props}
//       {...props}
//     >
//       <interactionContext.Provider
//         value={{
//           ...interactionBlock,
//           isOpen: props.isOpen,
//           updateItemsSeen: null,
//         }}
//       >
//         {(interactionBlock.children as Block[]).map(child => {
//           return renderBlock(child, Components);
//         })}
//       </interactionContext.Provider>
//     </Container>
//   );

//   return window.dev()
//     ? container
//     : useMemo(() => {
//         // console.log('hotSpot renders');
//         return container;
//       }, [props.isOpen, interactionBlock.props.lockDown]);

//   return (
//     <Container
//       id={interactionBlock.id}
//       key={interactionBlock.id}
//       {...interactionBlock.props}
//       {...props}
//     >
//       <interactionContext.Provider
//         value={{ ...interactionBlock, updateItemsSeen: null }}
//       >
//         {(interactionBlock.children as Block[]).map(child => {
//           return renderBlock(child, Components);
//         })}
//       </interactionContext.Provider>
//     </Container>
//   );
// };

export default HotSpotDisplay;
